export const CACHE_NAME_CLIENT_PERSONNEL_LIST = 'client/personnel/all';
export const CACHE_NAME_CLIENT_PERSONNEL_LIST_DETAILED = 'client/personnel/all/detailed';
export const CACHE_NAME_AUTH_TYPE_LIST = '/client/authorization-type/all';
export const CACHE_NAME_ORGANIZATION_LIST = '/organization/all';
export const CACHE_NAME_CLIENT_PERSONNEL_ID = 'client/personnel/id';

export const buildAppointmentFormFieldsCacheName = (locationId) => `/appointments/form-fields/location/${locationId}`;
export const buildInventoryItemTypeCacheName = (locationId) => `/inventory-item-types/location/${locationId}`;
export const buildInventoryItemTypeFormFieldsCacheName = (locationId) => `/inventory-item-types/form-fields/location/${locationId}`;
export const buildInventoryItemTypeColumnsCacheName = (locationId) => `/inventory-item-types/columns?locationId=${locationId}`;
